// @ts-nocheck
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import { TasksService } from './tasksService';

const TASKS = 'tasks';

export const TASKS_QUERY_KEYS = {
  ALL: [TASKS],

  pendingTasks: {
    ROOT: [TASKS, 'pendingTasks'],
    key: (params = {}) => [TASKS, 'pendingTasks', params],
  },

  taskQueue: {
    ROOT: [TASKS, 'taskQueue'],
    key: (params = {}) => [TASKS, 'taskQueue', params],
  },

  taskQueueFilter: {
    ROOT: [TASKS, 'taskQueueFilter'],
    key: (params = {}) => [TASKS, 'taskQueueFilter', params],
  },

  taskResult: {
    ROOT: [TASKS, 'taskResult'],
    key: (params = {}) => [TASKS, 'taskResult', params],
  },

  openTasks: {
    ROOT: [TASKS, 'openTasks'],
    key: (params = {}) => [TASKS, 'openTasks', params],
  },
};

export const usePendingTasksQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    TASKS_QUERY_KEYS.pendingTasks.key,
    TasksService.getPendingTasks,
    params,
    { loader: false, ...options }
  );

export const useTaskQueueQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    TASKS_QUERY_KEYS.taskQueue.key,
    TasksService.getTaskQueue,
    params,
    { loader: false, ...options }
  );

export const useTaskQueueFilterQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    TASKS_QUERY_KEYS.taskQueueFilter.key,
    TasksService.getTaskQueueFilter,
    params,
    options
  );

export const useTaskResultQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    TASKS_QUERY_KEYS.taskResult.key,
    TasksService.getTaskResult,
    params,
    options
  );

export const useOpenTasksQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    TASKS_QUERY_KEYS.openTasks.key,
    TasksService.getOpenTasks,
    params,
    { loader: false, ...options }
  );

export const useRetriggerAutomationMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useMutationEngine(TasksService.retriggerAutomation, options);
